import React from 'react';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-left">
          <p className="section-tag">ABOUT US</p>
          <h2 className="section-heading">About TAXICABS-247</h2>
          <p>TAXICABS-247 is a trusted provider of minicab services, operating 24/7 to meet diverse travel needs. With a strong commitment to safety and professionalism, our drivers are fully licensed and DBS-checked for complete passenger peace of mind.</p>
          <p>We offer a practical and affordable alternative to Black Cabs, with fares up to 35% lower without compromising on quality, comfort, or reliability.</p>
          <h3>What We Do</h3>
          <p>We provide comprehensive transport solutions including local trips, airport transfers, and wheelchair-accessible travel. Our fleet includes Saloon Cars, Executive Cars, MPVs, and 6 to 8-seater minibuses to support all group sizes and requirements.</p>
          <h3>What We Offer</h3>
          <div className="about-offer-box">
            <ul>
              <li>24/7 service available day and <strong>night</strong></li>
              <li>Fully licensed and DBS-checked drivers</li>
              <li>Wheelchair-accessible vehicle options</li>
              <li>Airport transfers for <strong>Heathrow</strong>, <strong>Gatwick</strong>, <strong>Stansted</strong>, <strong>Luton</strong>, and <strong>London City Airport</strong></li>
              <li>Fast booking via web or <strong>call on 02038393300</strong></li>
            </ul>
          </div>
        </div>
        <div className="about-right">
          <div className="mission-card">
            <h4>Our Mission</h4>
            <p>To provide safe, reliable, and affordable transportation services through skilled drivers, a modern fleet, and customer-first support for stress-free daily and airport journeys.</p>
          </div>
          <div className="mission-card">
            <h4>Our Vision</h4>
            <p>To be the most trusted and preferred TAXICABS-247 service, recognized for safety, affordability, and customer satisfaction while continuously improving booking and travel experiences.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
